import React from 'react';
import {EndOfYearReminders} from './Reminders.module';

export async function renderEOYReminders(root) {
    root.render(<EndOfYearReminders />);
}
